import { api } from 'shared/api'

import { GenerateTextSchema, ImproveTextSchema } from './schemas'

export const AiContentGeneratorApi = {
  generateText: api.account.createPost({
    url: '/aIAssistant/generateText',
    schemas: GenerateTextSchema,
  }),

  improveText: api.account.createPost({
    url: '/aIAssistant/improveText',
    schemas: ImproveTextSchema,
  }),
}
